import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fec5664"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shop-purchase" }
const _hoisted_2 = {
  key: 0,
  class: "shop-title"
}
const _hoisted_3 = { class: "shop-info" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "form-content" }
const _hoisted_6 = { class: "flex-ter form-content-label" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "abs flex-cen-ter",
  style: {"right":"15px","height":"34px","top":"0"}
}, "%", -1))
const _hoisted_9 = { class: "form-block" }
const _hoisted_10 = { class: "form-content-label-title" }
const _hoisted_11 = { class: "form-content-label-text flex-ter" }
const _hoisted_12 = { class: "form-content-label-text-tip" }
const _hoisted_13 = { class: "tip-label" }
const _hoisted_14 = { class: "form-input rel" }
const _hoisted_15 = {
  key: 0,
  class: "radio-div"
}
const _hoisted_16 = { class: "radio-div" }
const _hoisted_17 = { class: "radio-div" }
const _hoisted_18 = {
  key: 0,
  class: "text-rt mt_50 btn-block"
}
const _hoisted_19 = {
  key: 1,
  class: "text-rt mt_50"
}

import { t } from '@/plugins/i18n'
import { ref, computed, onMounted, reactive, watch } from 'vue'
import { purchaseCfg, purchaseUpt } from '@/apis/setup'
import useEdited from '@/util/useEdited'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import { useGlobal } from '@/util/useLoading'
import HelpTooltip from '@/components/common/helpTooltip.vue'
import { debounce } from 'lodash'
import { isD2C, useSite, isEN, isJA } from '@/store'
import { myShopIcons } from '@/store/modules/bussiness'

export default /*#__PURE__*/_defineComponent({
  props: ['vip', 'shopData'],
  emits: ['ok'],
  setup(__props, { expose, emit }) {

const props = __props
const questionIcon = require('@/assets/image/icon/question-black-icon.png')

const store = useStore()
const curShop = computed(() => store.state.route.curShop)
const shopInfo = computed(() => {
  if (props.shopData) return props.shopData
  let shop = {}
  store.getters.user.customerShopList.forEach((item: any) => {
    if (item.customerShopId === store.state.route.curShop) {
      shop = item
    }
  })
  const shopInfoDefault = store.state.route.shopInfo
  return (shopInfoDefault.customerShopName || shopInfoDefault.customerShopPlatName) ? shopInfoDefault : shop
})
const isEdit = computed(() => store.getters.editing)

const init = async () => {
  const api = useGlobal(purchaseCfg)
  if (!shopInfo.value.customerShopId) return
  const {
    purchasePriceAdd,
    payRepurchaseType
  } = await api({
    customerShopId: shopInfo.value.customerShopId
  }).then((res) => res.data)
  model.payRepurchaseType = payRepurchaseType ?? 0
  model.purchasePriceAdd = purchasePriceAdd ?? 0
}
init()
watch(shopInfo, () => {
  model.payRepurchaseType = 0
  model.purchasePriceAdd = 0
  if (shopInfo.value.customerShopId) {
    init()
  }
})
const origin = {
  payRepurchaseType: 0,
  purchasePriceAdd: 0
}
const firstpadd = ref(0)
// b2b选中次品重拍
const isB2bChooseOne = ref(false)
if (!isD2C()) {
  isB2bChooseOne.value = origin.payRepurchaseType === 1
}
const isD2CChoose = computed(() => {
  if (shopInfo.value.systemSource) {
    return shopInfo.value.systemSource === 1
  }
  return isD2C()
})
const model = reactive(origin)
// const [model, update, clear, reset] = useEdited(origin, () => {

// })
const api = useGlobal(purchaseUpt)
const update = () => {
  api({
    ...model,
    customerShopId: shopInfo.value.customerShopId
  }).then((res) => {
    if (res.success) {
      console.log(res)
      ElMessage.success(t('修改成功'))
      model.payRepurchaseType !== 1 && (isB2bChooseOne.value = false)
      // clear()
      emit('ok')
    }
  })
}
const firstupdate = () => {
  api(model).then(() => {
    firstpadd.value = model.purchasePriceAdd
    // clear()
    ElMessage.success(t('修改成功'))
    isB2bChooseOne.value = false
    emit('ok')
  })
}
const tip = [
  '当您采购的商品价格出现变化时，或不能采购时我们将为您寻找其他相同的商品，所以请告诉我您能接受的价格变动幅度。',
  '$接受次品重拍文案$',
  '$次品退货退款文案$',
  '$次品退货退款文案D2C$',
  '$每次询问我处理次品方式$'
]

const handle = debounce((v: any) => {
  model.payRepurchaseType = v
}, 100)

const checkForm = (success: any, error: any) => {
  if ((!model.purchasePriceAdd && model.purchasePriceAdd !== 0) || (!model.payRepurchaseType && model.payRepurchaseType !== 0)) {
    error()
  } else {
    success()
  }
}


expose({
  checkForm,
  update,
  firstupdate
})

return (_ctx: any,_cache: any) => {
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (props.vip && (_unref(curShop) || _unref(shopInfo).customerShopName || _unref(shopInfo).customerShopPlatName))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: _unref(myShopIcons)[_unref(shopInfo).shopPlatform || _unref(shopInfo).customerShopPlatform],
                alt: ""
              }, null, 8, _hoisted_4),
              _createElementVNode("span", null, _toDisplayString(_unref(shopInfo).customerShopName || _unref(shopInfo).customerShopPlatName), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", _hoisted_6, [
          _hoisted_7,
          _createTextVNode(_toDisplayString(_unref(t)("您能接受的采购价格上涨")) + " ", 1),
          _createVNode(HelpTooltip, {
            tip: _unref(t)(tip[0]),
            icon: _unref(questionIcon)
          }, null, 8, ["tip", "icon"])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["form-input", _unref(useSite)()])
        }, [
          _createVNode(_component_el_input_number, {
            class: "form-input-num",
            min: 0,
            max: 100,
            controls: false,
            modelValue: _unref(model).purchasePriceAdd,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).purchasePriceAdd) = $event)),
            style: {"width":"100%","height":"34px","line-height":"34px"}
          }, null, 8, ["modelValue"]),
          _hoisted_8
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)("次品付费重购")), 1),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('请决定发生次品时，您的重拍设置')), 1),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('次品默认退货退款')), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_radio_group, {
            "model-value": _unref(model).payRepurchaseType,
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              (_unref(isD2CChoose) || isB2bChooseOne.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(_component_el_radio, {
                      label: 1,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(handle)(1))),
                      class: "form-input-radio"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)("接受次品重拍")) + " ", 1),
                        _createVNode(HelpTooltip, {
                          tip: _unref(t)(tip[1]).replace(/X/g, () => _unref(isD2CChoose) ? '1' : '0'),
                          icon: _unref(questionIcon)
                        }, null, 8, ["tip", "icon"]),
                        _createElementVNode("span", {
                          class: "abs tip",
                          style: _normalizeStyle(_unref(isEN)() ? 'position: absolute;top: 100px' : '')
                        }, _toDisplayString(_unref(t)("接受次品重拍，有助于我们更好的为您完成C端订单")), 5)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_el_radio, {
                  label: 2,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(handle)(2)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("次品退货退款")) + " ", 1),
                    _createVNode(HelpTooltip, {
                      tip: _unref(isD2CChoose) ? _unref(t)(tip[3]) : _unref(t)(tip[2]),
                      icon: _unref(questionIcon)
                    }, null, 8, ["tip", "icon"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_el_radio, {
                  label: 0,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(handle)(0)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("每次询问我处理次品方式")), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["model-value"])
        ])
      ]),
      (!props.vip)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (firstpadd.value !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: update
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("保存")), 1)
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    class: "dark",
                    onClick: firstupdate
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("保存")), 1)
                    ]),
                    _: 1
                  })
                ]))
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})